import {slideToggle} from './utils';

const container = document.querySelector('.js-filters'),
    list = document.querySelector('.js-filters-list'),
    listToggle = document.querySelector('.js-filters-toggle');

// Add click handler to list toggle
if (listToggle) {
    listToggle.addEventListener('click', e => {
        e.preventDefault();

        container.classList.toggle('open');

        slideToggle(list, 500);
    });
}